import axios from 'axios'
import laroute from '~/laroute'
import store from '~/store'

// state
export const state = {
  listBySo: []
}

// getters
export const getters = {
  listBySo: state => state.listBySo
}

// mutations
export const mutations = {
  LIST_BY_SO (state, data) {
    state.listBySo = data
  }
}

// actions
export const actions = {
  async getProductsBySo ({ commit }, id) {
    await axios.get(laroute.route('get-products-by-so', { companyAbbr: store.getters['auth/company'], id: id })).then((res) => {
      commit('LIST_BY_SO', res.data)
    })
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/appCompanyProduct.js